import React, { useEffect, useState } from "react";
import { Order } from "../../../../../services";
import style from "./InsuranceStatus.module.scss";
import cn from "classnames";
import ClockIcon2 from "../../../../shared/icons/ClockIcon2";
import ErrorIcon from "../../../../shared/icons/ErrorIcon";
import ShieldCheckIcon from "../../../../shared/icons/ShieldCheckIcon";
import ShareSquareIcon from "../../../../shared/icons/ShareSquareIcon";
import { useTranslation } from "react-i18next";

const InsuranceStatus = ({ orderId, userType }) => {
  const { t } = useTranslation();
  const [insurance, setInsurance] = useState(null);

  useEffect(() => {
    if (!orderId || !userType) return;
    Order.getSabrInsuranceStatus(orderId, userType)
      .then((res) => setInsurance(res.data))
      .catch((err) => console.log(err));
  }, [orderId, userType]);

  if (!insurance) return null;

  const { status, paymentUrl } = insurance;

  if (status === "Active") {
    return (
      <div className={style.wrapper}>
        <div className={cn(style.left, style.left_center)}>
          <div className={style.icon}>
            <ShieldCheckIcon />
          </div>
          <p className={style.title}>{t("insuranceStatus.title")}</p>
        </div>
        <span className={cn(style.badge, style.badge_active)}>{t("insuranceStatus.statusActive")}</span>
      </div>
    );
  }

  if (status === "Cancelled") {
    return (
      <div className={style.wrapper}>
        <div className={cn(style.left, style.left_center)}>
          <div className={style.icon}>
            <ErrorIcon />
          </div>
          <p className={style.title}>{t("insuranceStatus.title")}</p>
        </div>
        <span className={cn(style.badge, style.badge_cancelled)}>{t("insuranceStatus.statusCancelled")}</span>
      </div>
    );
  }

  if (status === "Pending") {
    return (
      <div className={style.wrapper}>
        <div className={style.left}>
          <div className={style.icon}>
            <ClockIcon2 />
          </div>
          <div className={style.text_block}>
            <p className={style.title}>{t("insuranceStatus.title")}</p>
            <div className={style.link_row}>
              <a
                href={paymentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={style.link}
              >
                {t("insuranceStatus.link")}
              </a>
              <span className={style.share_icon}>
                <ShareSquareIcon />
              </span>
            </div>
          </div>
        </div>
        <span className={cn(style.badge, style.badge_pending)}>{t("insuranceStatus.statusPending")}</span>
      </div>
    );
  }

  if (status) {
    return (
      <div className={style.debug_block}>
        <span className={style.debug_label}>Страхования</span>
        <span className={style.debug_label}>🧪 Для тестирования</span>
        <div className={style.debug_row}>
          <span className={style.debug_key}>status:</span>
          <span className={style.debug_value}>{status}</span>
        </div>
        <div className={style.debug_row}>
          <span className={style.debug_key}>paymentUrl:</span>
          {paymentUrl ? (
            <a href={paymentUrl} target="_blank" rel="noopener noreferrer" className={style.debug_url}>
              {paymentUrl}
            </a>
          ) : (
            <span className={style.debug_empty}>отсутствует</span>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default InsuranceStatus;
